import { Injectable } from '@angular/core';
import {ODataEntitySetResource, ODataEntitySetService, ODataServiceFactory} from 'angular-odata';
import {Calendar} from '../../features/dashboard/models/calendar';
import {exportable$} from '../table/decorators/exportable';
import {ParentTableService} from '../table/parent-table.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from '../table/mappers/odata-response-mapper';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';
import {HelperFunctions} from '../table/configuration/helper-functions';

@Injectable({
  providedIn: 'root'
})
export class DashboardCalendarService extends ParentTableService {
  private odata: ODataEntitySetService<Calendar>;
  private readonly config: SQDataConfiguration;
  @exportable$ calendar: ODataEntitySetResource<any>;
  constructor(private odataFactory: ODataServiceFactory, private httpService: HttpClient) {
    super('DashboardCalendarService');
    this.config = new SQDataConfiguration();
  }

  initialize(dashboardId: number) {
    this.odata = this.odataFactory.entitySet<Calendar>(`Dashboard(${dashboardId})/Calendar`);
  }

  getData(pageIndex, count, sortModel, filterModel) {
    let filter = '';
    const { suppliersFilters, otherFilters } = this.splitBySuppliersKey(filterModel);
    const otherFilterString = HelperFunctions.addOdataFilters('', otherFilters);
    const suppliersFilterString = HelperFunctions.addOdataFilters('', suppliersFilters);
    const filterParts = [
      otherFilterString,
      suppliersFilterString ? `Suppliers/any(Supplier: ${suppliersFilterString})` : null
    ];
    filter = filterParts.filter(Boolean).join(' AND ');

    const query = this.odata.entities().query(q => {
      if (filter && filter.length > 0) q.filter(filter);
      return q;
    });

    this.calendar = query;
    return this.calendar.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }

  exportCalendarData(): Observable<Blob> {
    const calendarUrl = this.calendar.api.serviceRootUrl + this.calendar.toString();
    return this.httpService.get(calendarUrl.replace('/Dashboard', '/ExportDashboard'), {responseType: 'blob'});
  }

  splitBySuppliersKey(filterModel: any): { suppliersFilters: any; otherFilters: any } {
    const suppliersFilters = {};
    const otherFilters = {};
    for (const key in filterModel) {
      if (key.startsWith('Supplier.')) {
        suppliersFilters[key] = filterModel[key];
      } else {
        otherFilters[key] = filterModel[key];
      }
    }
    return { suppliersFilters, otherFilters };
  }
}
